import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import TypewriterText from "../components/TypeWriterText";

const pages = [
  { title: "Curator's Foreword", path: "/foreword-apex" },
  {
    title: "Day 46: Gold and the Weight of the Past",
    path: "/apex-asset-46",
  },
  {
    title: "Day 47: Land and the Limits of Scarcity",
    path: "/apex-asset-47",
  },
  {
    title: "Day 48: Wall Street and the High Walls of Entry",
    path: "/apex-asset-48",
  },
  {
    title: "Day 49: Fiat Money and Paper Promises",
    path: "/apex-asset-49",
  },
  {
    title: "Day 50: Crypto and the Imitation of Sound Money",
    path: "/apex-asset-50",
  },
];

const IndexApexAsset = () => {
  // State for staggered animation
  const [visibleItems, setVisibleItems] = useState([]);
  // State for hover tracking
  const [hoveredIndex, setHoveredIndex] = useState(null);

  // Custom title text for the secondary title
  const titleText = "The Apex Asset";

  // Staggered animation effect
  useEffect(() => {
    pages.forEach((_, index) => {
      const delay = 50 * index;
      const timeoutId = setTimeout(() => {
        setVisibleItems((prevItems) => [...prevItems, index]);
      }, delay);
      return () => clearTimeout(timeoutId);
    });
  }, []);

  // Define the base style object for all links (matching IndexEconomics)
  const baseLinkStyle = {
    fontSize: "18px",
    width: "100%",
    padding: "15px 20px",
    margin: "0",
    textDecoration: "none",
    borderBottom: "1px solid #eee",
    color: "black",
    cursor: "pointer",
    textAlign: "left",
    transition:
      "color 0.3s ease, background-color 0.3s ease, transform 0.3s ease, opacity 0.5s ease, border-color 0.3s ease",
  };

  // Define the hover style (matching IndexEconomics)
  const hoverStyle = {
    backgroundColor: "#f9f9f9",
    color: "#034d28", // Dark Green text on hover
    transform: "translateX(5px)", // Subtle slide-right effect
    borderBottomColor: "#034d28", // Dark Green border on hover
  };

  return (
    <div
      style={{
         width: "95%",

        margin: "40px auto",
        padding: "0", // Remove padding to allow links to touch edges
        backgroundColor: "white",
        border: "2px solid #ccc",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
        overflowY: "auto",
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch", //
        fontFamily: "Georgia, sans-serif",
        lineHeight: "1.6",
        letterSpacing: "0.3px",
      }}
    >
      <h1
        style={{
          fontSize: "30px",
          fontWeight: "bold",
          textAlign: "center",
          marginBottom: "20px",
          marginTop: "20px",
          color: "black",
          padding: "0 20px", // Add padding back to the title
        }}
      >
        <b>Table of Contents</b>
        <br />
        <TypewriterText text={titleText} delay={80} />
      </h1>
      {pages.map((page, index) => {
        const isVisible = visibleItems.includes(index);
        const isHovered = hoveredIndex === index;

        return (
          <Link
            key={index}
            to={page.path}
            // Merge base style, animation style, and hover style
            style={{
              ...baseLinkStyle,
              // Animation style (fade in and slide up)
              ...(isVisible
                ? {}
                : { opacity: 0, transform: "translateY(20px)" }),
              // Hover style
              ...(isHovered ? hoverStyle : {}),
            }}
            // Hover handlers
            onMouseEnter={() => setHoveredIndex(index)}
            onMouseLeave={() => setHoveredIndex(null)}
          >
            {page.title}
          </Link>
        );
      })}
    </div>
  );
};

export default IndexApexAsset;
